export default __webpack_public_path__ + "static/media/DSCN6698.03793d9b.JPG";